/**
 * This is here to make testing easier.
 */
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const getActiveElement = () => document.activeElement as HTMLElement | null;
